import type {
  ActiveSessionLoadState,
  SessionLoadContext,
  SessionRenderOptions,
  SessionSyncReason,
} from '../types';
import { logScrollDebug } from '../ui/session-debug';

export function createSessionLoadContext(reason: SessionSyncReason): SessionLoadContext {
  return { reason };
}

export function getActiveSessionLoadContext(
  activeLoad: ActiveSessionLoadState | null | undefined,
  sessionId: string | null | undefined,
): SessionLoadContext | null {
  if (!activeLoad || !sessionId || activeLoad.sessionId !== sessionId) {
    logScrollDebug('load-context:miss', {
      requestedSessionId: sessionId || null,
      activeLoadSessionId: activeLoad?.sessionId || null,
      activeLoadReason: activeLoad?.context?.reason || null,
    });
    return null;
  }
  logScrollDebug('load-context:hit', {
    sessionId,
    reason: activeLoad.context?.reason || null,
    blocking: !!activeLoad.blocking,
  });
  return activeLoad.context || null;
}

export function shouldPreserveViewportForLoadContext(
  context: SessionLoadContext | null | undefined,
): boolean {
  return context?.reason === 'foreground_resync'
    || context?.reason === 'reconnect_resync'
    || context?.reason === 'background_task_sync'
    || context?.reason === 'completion_sync'
    || context?.reason === 'active_session_refresh';
}

export function getSessionRenderOptions(input: {
  immediate?: boolean;
  loadContext?: SessionLoadContext | null;
} = {}): SessionRenderOptions {
  const options = {
    immediate: !!input.immediate,
    preserveViewport: shouldPreserveViewportForLoadContext(input.loadContext),
  };
  logScrollDebug('render-options', {
    immediate: options.immediate,
    loadContextReason: input.loadContext?.reason || null,
    preserveViewport: options.preserveViewport,
  });
  return options;
}
